export default {
    'en': { 
        currency: { 
            style: 'currency', 
            currency: 'USD' 
        },
        percent: {
            style: 'percent',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        },
        number: {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        },
        numberInteger: {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0       
        },
        decimal8: {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 8
        },
        decimal3: {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 3
        },
        numberWithoutGrouping: {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: false
        },
    },
    'de': { 
        currency: { 
            style: 'currency', 
            currency: 'EUR' 
        },
        percent: {
            style: 'percent',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        },
        number: {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        },
        numberInteger: {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0       
        },
        decimal8: {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 8
        },
        decimal3: {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 3
        },
        numberWithoutGrouping: {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: false
        },
    },
    'ko': { 
        currency: { 
            style: 'currency', 
            currency: 'KRW' 
        },
        percent: {
            style: 'percent',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        },
        number: {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        },
        numberInteger: {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0       
        },
        decimal8: {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 8
        },
        decimal3: {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 3
        },
        numberWithoutGrouping: {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: false
        },
    },
    // -------------------------------------- //
    'EUR': { 
        currency: { 
            style: 'currency', 
            currency: 'EUR' 
        }
    },
    'USD': { 
        currency: { 
            style: 'currency', 
            currency: 'USD' 
        } 
    },
    'EU': { 
        percent: {
            style: 'percent',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        },
    },
    'US': { 
        percent: {
            style: 'percent',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        },
    },
    'KRW': {
        currency: { 
            style: 'currency', 
            currency: 'KRW' 
        }
    }
}